module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_iterators.js
// module id = 680
// module chunks = 25